import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeaksDialog(props) {
  const {
    heading,
    message,
    okButton,
    cancelButton,
    setDeleteDialogOpen,
    deleteDialogOpen,
    confirmFunction,
  } = props;

  const handleClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleOperation = () => {
    confirmFunction();
  };

  return (
    <div>
      <Dialog
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{heading}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            {cancelButton}
          </Button>
          <Button
            id="bang"
            onClick={() => {
              handleOperation();
            }}
          >
            {okButton}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
